import { useEffect, useState } from "react";

const Levels = () => {
  const [levels, setLevels] = useState([]);

  useEffect(() => {
    const fetchLevelData = async () => {
      try {
        const response = await fetch("https://api.pixelore.wiki/api/levels");
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        // Convert the object to an array
        const levelsArray = Object.values(data);
        setLevels(levelsArray);
      } catch (error) {
        console.error("Failed to fetch level data", error);
      }
    };

    fetchLevelData();
  }, []);

  return (
    <div>
      <h2 className="panel-heading">Known Levels in Pixels</h2>
      <div className="component-style">
        <table className="market-table text-center">
          <thead>
            <tr>
              <th>Level</th>
              <th>
                Total
                <br />
                Experience
              </th>
              <th>Exp to Level Up</th>
            </tr>
          </thead>
          <tbody>
            {levels &&
              Object.values(levels)
                .sort((a, b) => a.level - b.level)
                .map((level) => (
                  <tr key={level.level}>
                    <td>{level.level}</td>
                    <td>{Number(level.exp).toLocaleString()}</td>
                    <td>{Number(level.nextLevelExp).toLocaleString()}</td>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Levels;
